var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-sidebar",
    {
      attrs: {
        id: "sidebar-1",
        "text-variant": "light",
        backdrop: "",
        shadow: "",
        title: _vm.$t("sidebar.otherApps")
      }
    },
    [
      _c("div", { staticClass: "asc__sidebar-header p-4" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "px-3 py-2 asc__sidebar-body text-center" },
        _vm._l(_vm.otherApps, function(app, i) {
          return _c("b-card", { key: "otherapp" + i, staticClass: "mb-3" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    app.SuccessReturnUrl +
                    "?authKey=" +
                    encodeURIComponent(_vm.cuaKey) +
                    "&redirectHash=" +
                    app.Hash +
                    "&hash=" +
                    _vm.hash,
                  target: "_blank"
                }
              },
              [_vm._v("\n        " + _vm._s(app.Name) + "\n      ")]
            )
          ])
        }),
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d622f5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d622f5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = null
// module chunks = 